import { Component, EventEmitter, Injector, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlContainer, FormControl, NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { GridComponent } from '@progress/kendo-angular-grid';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from 'src/app-core/constants/common-constants';
import { CommonService } from 'src/app-core/services/common.service';
import { ItemService } from 'src/app/item/item.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { CommonDataModel } from '../common-data-model';
import { OrdersCopyContainerItemFormComponent } from '../orders-copy-container-item-form/orders-copy-container-item-form.component';
import { CommonMethod } from 'src/app-core/methods/common-methods';
const hasClass = (el, className) => new RegExp(className).test(el.className);
const isChildOf = (el, className) => {
    while (el && el.parentElement) {
        if (hasClass(el.parentElement, className)) {
            return true;
        }
        el = el.parentElement;
    }
    return false;
};

@Component({
    selector: 'app-orders-container-item-list',
    templateUrl: './orders-container-item-list.component.html',
    styleUrls: ['./orders-container-item-list.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    encapsulation: ViewEncapsulation.None,
})
export class OrdersContainerItemListComponent extends AppComponentBase implements OnInit {
    @ViewChild('grid', { static: true }) grid: GridComponent;
    @ViewChild('containerItemListForm', { static: true }) containerItemListForm: NgForm;
    @ViewChild('itemAutocomplete', { static: true }) public itemAutocomplete: AutoCompleteComponent;
    @Output() emitContainerItem: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitSetDefaulContainerAndPackaging: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitRemoveDefaulContainerAndPackaging: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitItemQuantityAndValueChangeEvent: EventEmitter<any> = new EventEmitter<any>();
    @Input() containerId: any;
    @Input() isNewOrder: boolean;
    @Input() readOnly: boolean;
    @Input() set containerListForm(paramObject: any) {
        this.parentForm = paramObject;
    }
    @Input() set containerParams(container: any) {
        this.gridItems = container;
        this.gridItems.data = container.lineItems;
        this.gridItems.total = container.lineItems.length;
        this.gridItems.isUnit = false;
        
        if (this.gridItems.data) {
            this.onSelectItemChange();
            this.gridItems.data.forEach((dataItem) => {
                this.commonMethod.sendValue(dataItem.value);
            });
        }
        this.gridItems.data.map((item, index) => item.id = `item_${index + 1}`);
        this.initialItems = _.cloneDeep(this.gridItems.data);
        if (container.containerTotals) {
            this.containerTotals = container.containerTotals;
            this.gridItems.idl = container.containerTotals.idl;
            this.gridItems.idh = container.containerTotals.idh;
            this.gridItems.idw = container.containerTotals.idw;
        } else {
            this.containerTotals = Object.assign({}, this.commonDataModal.containerTotalsModel);
        }
        this.onCalculateTotals();
        this.innerDimentionCalculation();
    }

    containerTotals: any;
    item: any;
    editedRowIndex: any;
    categories: Array<any>;
    itemNames: Array<any>;
    totalExtLbs: any;
    totalExtValue: any;
    parentForm: any = new FormControl();
    commonDataModal = new CommonDataModel();
    initialItems: Array<any>;
    combinedItems: Array<any>;
    gridItems: any = {
        data: [],
        total: 0,
        isUnit: false
    };
    allItemsSelected = false;
    isIDLUserChanged = false;
    isIDHUserChanged = false;
    isIDWUserChanged = false;
    commonConstants: typeof CommonConstants = CommonConstants;

    constructor(
        private itemService: ItemService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private renderer: Renderer2,
        private commonMethod: CommonMethod,
        private commonService: CommonService,
        injector: Injector) {
        super(injector);
        this.renderer.listen(
            'document',
            'click',
            ({ target }) => {
                if (!isChildOf(target, 'containerItemGrid')) {
                    if (this.containerItemListForm.valid) {
                        this.grid.closeRow(this.editedRowIndex);
                        this.editedRowIndex = false;
                    }
                }
            });
    }

    ngOnInit(): void {
        this.getCategories();
        this.getItemNames();
        this.onCalculateTotals();
    }

    getCategories(): void {
        this.itemService.getCategories().subscribe(response => {
            if (response.isSuccess) {
                this.categories = response.data;
            }
        });
    }

    getItemNames(): void {
        this.itemService.getItemLookup('').subscribe(response => {
            this.itemNames = response.data;
        });
    }

    onItemClick(data: any, itemAutocomplete: any) {
        if (itemAutocomplete) {
            itemAutocomplete.searchbar.input.nativeElement.setAttribute('maxlength', 100);
        }
        if (data.categoryId) {
            const filtereNames = this.itemNames.filter(item => item.itemCategoryId === data.categoryId && item.itemName.toLowerCase());
            if (data.itemName) {
                itemAutocomplete.dataService.data = filtereNames.filter((s) => s.itemName.toLowerCase().indexOf(data.itemName.toLowerCase()) !== -1).map(x => x.itemName);
            } else {
                itemAutocomplete.dataService.data = filtereNames.map(x => x.itemName);
            }
        } else {
            if (data.itemName) {
                itemAutocomplete.dataService.data = this.itemNames.filter((s) => s.itemName.toLowerCase().indexOf(data.itemName.toLowerCase()) !== -1).map(x => x.itemName);
            } else {
                itemAutocomplete.dataService.data = this.itemNames.map(x => x.itemName);
            }
        }
        itemAutocomplete.togglePopup(true);
    }

    onHandleFilter(value: any, itemAutocomplete: any) {
        itemAutocomplete.togglePopup(true);
        if (value) {
            itemAutocomplete.dataService.data = this.itemNames.filter((s) => s.itemName.toLowerCase().indexOf(value.toLowerCase()) !== -1).map(x => x.itemName);
            return;
        }
        itemAutocomplete.dataService.data = this.itemNames.map(x => x.itemName);
    }

    onItemNameChange(value: any, dataItem: any) {
        const selectedItem = this.itemNames.find(item => item.itemName === value);
        if (selectedItem) {
            this.itemService.getItem(`Id=${selectedItem.itemId}`).subscribe(response => {
                if (response.isSuccess) {
                    this.commonService.objectMapping(dataItem, response.data);
                    dataItem.defaultCrateId = response.data.defaultCrateId;
                    dataItem.defaultPackagingId = response.data.defaultPackagingId;
                    dataItem.itemId = selectedItem.itemId;
                    dataItem.categoryId = selectedItem.itemCategoryId;
                    const selectedCategories = this.categories.find(categories => categories.id === dataItem.categoryId);
                    dataItem.categoryName = selectedCategories.categoryName;
                    dataItem.isChanged = true;
                    this.onCalculateTotals();
                    this.resetIDHUserChangedvalues();
                    this.innerDimentionCalculation();
                    if (this.gridItems.data.length === 1) {
                        this.emitSetDefaulContainerAndPackaging.emit({ dataItem, containerId: this.containerId });
                    }
                    this.emitItemQuantityAndValueChangeEvent.emit(this.containerTotals);
                }
            });
        } else {
            dataItem.itemId = null;
            if(!value && !dataItem.itemId) {
                dataItem.categoryId = null;
            }
        }
    }

    onCategoryChange(event: any, dataItem: any) {
        if (event.id) {
            dataItem.categoryId = event.id;
            dataItem.categoryName = event.categoryName;
            dataItem.itemName = null;
            dataItem.itemId = null;
            dataItem.isChanged = true;
            this.getItemNames();
            this.setHazmatDefault();
        }
    }

    setHazmatDefault() {
        this.emitContainerItem.emit();
    }

    insertItem() {
        this.gridItems.data.splice(0, 0, this.item.lineItems.items[0]);
    }

    onCellClickHandler({ sender, rowIndex }, grid: any) {
        grid.closeRow(this.editedRowIndex);
        this.editedRowIndex = rowIndex;
        sender.editRow(rowIndex);
    }

    onQuantityChange(dataItem: any, rowIndex: string) {
        dataItem.isChanged = true;
        if (dataItem.quantity) {
            const quantityInNumber = parseInt(dataItem.quantity);
            if (!quantityInNumber) {
                this.gridItems.data[rowIndex].quantity = '1';
                return;
            }
            dataItem.extValue = quantityInNumber * dataItem.value;
            this.onCalculateTotals();
            dataItem.extlbs = quantityInNumber * dataItem.weight;
            this.resetIDHUserChangedvalues();
            this.innerDimentionCalculation();
            this.emitItemQuantityAndValueChangeEvent.emit(this.containerTotals);
        }
    }

    onLengthChange(dataItem: any) {
        dataItem.isChanged = true;
        this.resetIDHUserChangedvalues();
        this.innerDimentionCalculation();
    }

    onWeightChange(dataItem: any) {
        dataItem.isChanged = true;
        if (!dataItem.quantity) {
            dataItem.extlbs = 0;
        } else {
            dataItem.extlbs = parseInt(dataItem.quantity) * dataItem.weight;
        }
        if (this.gridItems.data.length === 1) {
            if (dataItem.weight && dataItem.itemId) {
                this.emitSetDefaulContainerAndPackaging.emit({ dataItem, containerId: this.containerId, weight: dataItem.weight, value: dataItem.value });
            }
        }
        this.onCalculateTotals();
        this.innerDimentionCalculation(this.commonConstants.appComponent.weight);
    }

    onValueChange(dataItem: any) {
        dataItem.isChanged = true;
        this.commonMethod.sendValue(dataItem.value);
        dataItem.extValue = parseInt(dataItem.quantity) * dataItem.value;
        if (this.gridItems.data.length === 1) {
            if (dataItem.value && dataItem.itemId) {
                this.emitSetDefaulContainerAndPackaging.emit({ dataItem, containerId: this.containerId, value: dataItem.value, weight: dataItem.weight });
            }
        }
        this.onCalculateTotals();
        this.emitItemQuantityAndValueChangeEvent.emit(this.containerTotals);
    }

    onDeleteItem(rowIndex: number, dataItem: any) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'confirm_layout',
            hasBackdrop: false,
            data: CommonConstants.appComponent.deletConfirmation,
        }).afterClosed()
            .subscribe((response: { confirmResult: boolean }) => {
                if (response && response.confirmResult === true) {
                    dataItem.isActive = false;
                    this.gridItems.data.splice(rowIndex, 1);
                    this.resetIDHUserChangedvalues();
                    this.innerDimentionCalculation();
                    this.gridItems.data.map((item, index) => item.id = `item_${index + 1}`);
                    this.setHazmatDefault();
                    this.containerItemListForm.form.markAsDirty();
                    if (rowIndex === 0) {
                        this.emitRemoveDefaulContainerAndPackaging.emit(this.containerId);
                    }
                    this.emitItemQuantityAndValueChangeEvent.emit(this.containerTotals);
                }
            });
    }

    getEmptyItem(): any {
        const commonDataModel = new CommonDataModel();
        const itemModel = commonDataModel.quickQuoteItem;
        itemModel.quantity = 1;
        itemModel.categoryId = null;
        itemModel.categoryName = null;
        itemModel.itemName = null;
        itemModel.itemId = null;
        itemModel.description = null;
        itemModel.isChanged = true;
        itemModel.length = 0;
        itemModel.width = 0;
        itemModel.height = 0;
        itemModel.weight = 0;
        itemModel.value = 0;
        itemModel.extlbs = 0;
        itemModel.extValue = 0;
        itemModel.nmfcClass = "85";
        itemModel.isOrientationLocked = false;
        itemModel.isActive = true;
        return itemModel;
    }

    onAddNewItem() {
        this.gridItems.data.push(this.getEmptyItem());
        this.containerItemListForm.form.markAsDirty();
    }

    onCopyAndCreateItem(dataItem: any) {
        this.dialog.open(OrdersCopyContainerItemFormComponent, {
            panelClass: 'small_center_layout',
            hasBackdrop: false,
            data: { containerDetails: {} },
        }).afterClosed().subscribe((response: any) => {
            if (response && response.confirmResult === true) {
                for (let i = 0; i < response.quantity; i++) {
                    const newItem = Object.assign({}, dataItem);
                    newItem.lineItemId = null;
                    this.gridItems.data.push(newItem);
                    this.gridItems.data.map((item, index) => item.id = `item_${index + 1}`);
                    this.containerItemListForm.form.markAsDirty();
                }
                this.onCalculateTotals();
                this.emitItemQuantityAndValueChangeEvent.emit(this.containerTotals);
            }
        });
    }

    validateItemForCopy(dataItem: any): boolean {
        if (!dataItem.categoryId || !dataItem.itemName) {
            this.toastr.warning('Please select Category and Item name to copy');
            return false;
        }
        return true;
    }

    onCategoryOpen(index: number) {
        if (index !== this.editedRowIndex) {
            if (this.containerItemListForm.valid) {
                this.grid.closeRow(this.editedRowIndex);
                this.editedRowIndex = index;
                this.grid.editRow(index);
            }
        }
    }

    onCalculateTotals() {
        if (this.gridItems.data) {
            const getExtLabs = this.gridItems.data.filter(item => item.extlbs).map(x => x.extlbs);
            this.totalExtLbs = getExtLabs.length ? getExtLabs.reduce((a, b) => (+a) + (+b)) : 0;
            const getExtValue = this.gridItems.data.filter(item => item.extValue).map(x => x.extValue);
            this.totalExtValue = getExtValue.length ? getExtValue.reduce((a, b) => (+a) + (+b)) : 0;
            if (this.isNewOrder) {
                this.containerTotals.totalEXTLBS = this.totalExtLbs;
                this.containerTotals.totalEXTValue = (this.totalExtValue % 1) ? this.totalExtValue.toFixed(2) : this.totalExtValue;
            }
        }
    }

    innerDimentionCalculation(fieldType?: string) {
        if (this.gridItems.data && this.gridItems.data.length > 0) {

            let dimensionModified = [];
            const ITEMS_GROUP_SET = 3;
            this.gridItems.data.forEach(item => {
                if (item.quantity > 1) {
                    for (let i = 0; i < item.quantity; i++) {
                        dimensionModified.push(
                            {
                                height: item.height,
                                length: item.length,
                                width: item.width,
                                isOrientationLocked: item.isOrientationLocked
                            });
                    }
                } else {
                    dimensionModified.push(
                        {
                            height: item.height,
                            length: item.length,
                            width: item.width,
                            isOrientationLocked: item.isOrientationLocked
                        });
                }
            });
            let count = dimensionModified.length;
            // calculation is only if items are more than 1
            if (dimensionModified.length !== 1) {
                if (dimensionModified.length <= 4) {
                    const innDime = this.getCalInnerDimentions(dimensionModified);
                    const contDime = {
                        idl: innDime.length,
                        idw: innDime.width,
                        idh: innDime.height
                    };
                    this.setContainerDimentions(contDime);
                } else {
                    while (count > 4) {
                        const tempDimensions = [];

                        if (count > 4) {
                            let startCount = 0;
                            for (let _count = 0; _count < dimensionModified.length; _count += ITEMS_GROUP_SET) {
                                let endCount = _count + ITEMS_GROUP_SET;
                                startCount = _count;
                                if (endCount >= dimensionModified.length) {
                                    endCount = dimensionModified.length;
                                }
                                const itemSetList = [];
                                for (let _itemsCount = startCount; _itemsCount < endCount; _itemsCount++) {
                                    itemSetList.push(
                                        {
                                            length: dimensionModified[_itemsCount].length,
                                            width: dimensionModified[_itemsCount].width,
                                            height: dimensionModified[_itemsCount].height,
                                            isOrientationLocked: dimensionModified[_itemsCount].isOrientationLocked
                                        }); // add items to make set based on ITEMS_GROUP_SET constant
                                }
                                let sortBeforeAdd = {};
                                sortBeforeAdd = this.getCalInnerDimentions(itemSetList);
                                tempDimensions.push(_.cloneDeep(sortBeforeAdd)); // add temrarely calculated dimension list to assign it back to input variable dimension list
                            }
                            dimensionModified = tempDimensions;
                            count = dimensionModified.length;
                        }
                    }
                    const dimensionsLocal = this.getCalInnerDimentions(dimensionModified);
                    const contDime = {
                        idl: dimensionsLocal.length,
                        idw: dimensionsLocal.width,
                        idh: dimensionsLocal.height
                    };
                    this.setContainerDimentions(contDime);
                }
            } else {
                if (fieldType === this.commonConstants.appComponent.weight) {
                    const contDime = {
                        idl: this.gridItems.idl,
                        idw: this.gridItems.idw,
                        idh: this.gridItems.idh
                    };
                    this.setContainerDimentions(contDime);
                    return;
                }
                const contDime = {
                    idl: this.gridItems.data[0].length ? this.gridItems.data[0].length : 0,
                    idw: this.gridItems.data[0].width ? this.gridItems.data[0].width : 0,
                    idh: this.gridItems.data[0].height ? this.gridItems.data[0].height * (this.gridItems.data[0].quantity ? this.gridItems.data[0].quantity : 1) : 0
                };
                this.setContainerDimentions(contDime);
            }
        }
    }

    resetIDHUserChangedvalues() {
        this.gridItems.isIDLUserChanged = false;
        this.gridItems.isIDWUserChanged = false;
        this.gridItems.isIDHUserChanged = false;
    }

    setContainerDimentions(containerDimen) {
        if (!this.gridItems.isIDLUserChanged) {
            this.gridItems.idl = containerDimen.idl;
        }
        if (!this.gridItems.isIDWUserChanged) {
            this.gridItems.idw = containerDimen.idw;
        }
        if (!this.gridItems.isIDHUserChanged) {
            this.gridItems.idh = containerDimen.idh;
        }
    }

    getCalInnerDimentions(itemList: any): any {
        let innerDimLength = 0;
        let innerDimWidth = 0;
        let innerDimHeight = 0;
        const containerInnDimModel = this.commonDataModal.containerInnerDimentionsModel;
        if (itemList.length > 1) {
            itemList.forEach(item => {
                const itemsArray = [
                    item.length ? +item.length : 0,
                    item.width ? +item.width : 0,
                    item.height ? (+item.height) : 0
                ];
                // sort item dimension in descending order
                let sortedArray = [];
                if (!item.isOrientationLocked) {
                    sortedArray = itemsArray.sort((el1, el2) => el2 - el1);
                } else {
                    sortedArray = itemsArray;
                }
                // take the maximum value as the length ie; index 0
                // assign to local variable if previous item length is less then current
                if (innerDimLength < sortedArray[0]) {
                    innerDimLength = sortedArray[0];
                }
                // take the center value as the width ie; index 1
                // assign to local variable if previous item width is less then current
                if (innerDimWidth < sortedArray[1]) {
                    innerDimWidth = sortedArray[1];
                }
                // take the last value as the height ie; index 2
                // take the sum of all the last index value as height
                innerDimHeight = (innerDimHeight + sortedArray[2]);
            });
            containerInnDimModel.length = innerDimLength;
            containerInnDimModel.width = innerDimWidth;
            containerInnDimModel.height = innerDimHeight;
        } else if (itemList.length === 1) {
            containerInnDimModel.length = itemList[0].length;
            containerInnDimModel.width = itemList[0].width;
            containerInnDimModel.height = itemList[0].height;
        } else {
            containerInnDimModel.length = 0;
            containerInnDimModel.width = 0;
            containerInnDimModel.height = 0;
        }

        return containerInnDimModel;
    }

    onShowActionButton() {
        const selectedItems = this.gridItems.data.filter(item => item.isSelected);
        return (selectedItems.length > 1) ? true : false;
    }

    onSelectAllItemsChange(event): void {
        this.allItemsSelected = event.checked;
        this.gridItems.data.map(item => item.isSelected = event.checked);
    }

    onSelectItemChange(): void {
        const notSelected = this.gridItems.data.filter(item => !item.isSelected);
        (notSelected.length === 0) ? this.allItemsSelected = true : this.allItemsSelected = false;
    }

    onIDLChange() {
        this.gridItems.isIDLUserChanged = true;
    }

    onIDHChange() {
        this.gridItems.isIDHUserChanged = true;
    }

    onIDWChange() {
        this.gridItems.isIDWUserChanged = true;
    }

    showExtUnit() {
        this.gridItems.isUnit = !this.gridItems.isUnit;
    }
}
